/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClientProfileResponse,
  ClientSectionPatch,
  ClientSectionPatchResult,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Save one section of a client's profile, and record deliberate skips.
 *
 * Lets an advisor save what they know now instead of completing every step or
 * losing the work. Fields listed in `deferred` are recorded as the client's to
 * supply, so the completeness report excuses them rather than reporting them as
 * gaps — an empty field alone cannot tell those two situations apart.
 *
 * The response says what was stored and where, so a partial save is never
 * silently partial.
 * @summary Patch Client Section
 */
export const patchClientSection = (
    clientId: string,
    clientSectionPatch: ClientSectionPatch,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<ClientSectionPatchResult>(
      {url: `/clients/${clientId}/profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: clientSectionPatch, signal
    },
      options);
    }




export const getPatchClientSectionMutationKey = () => ['patchClientSection'] as const;

export const getPatchClientSectionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClientSection>>, TError,PatchClientSectionMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof patchClientSection>>, TError,PatchClientSectionMutationVariables, TContext> => {

const mutationKey = getPatchClientSectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchClientSection>>, PatchClientSectionMutationVariables> = (props) => {
          const {clientId,data} = props ?? {};

          return  patchClientSection(clientId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchClientSectionMutationResult = NonNullable<Awaited<ReturnType<typeof patchClientSection>>>
    export type PatchClientSectionMutationBody = ClientSectionPatch
    export type PatchClientSectionMutationError = HTTPValidationError
    export type PatchClientSectionMutationVariables = {clientId: string;data: ClientSectionPatch}

    /**
 * @summary Patch Client Section
 */
export const usePatchClientSection = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchClientSection>>, TError,PatchClientSectionMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchClientSection>>,
        TError,
        PatchClientSectionMutationVariables,
        TContext
      > => {
      return useMutation(getPatchClientSectionMutationOptions(options));
    }
    /**
 * The client's identity / contact / KYC detail for the profile page.
 *
 * Projects the client's most recent onboarding verified profile + KYC
 * documents on top of the directory row — the directory list stays thin.
 * @summary Get Client Profile
 */
export const getClientProfile = (
    clientId: string,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<ClientProfileResponse>(
      {url: `/clients/${clientId}/profile`, method: 'GET', signal
    },
      options);
    }




export const getGetClientProfileQueryKey = (clientId: string,) => {
    return [
    `/clients/${clientId}/profile`
    ] as const;
    }


export const getGetClientProfileQueryOptions = <TData = Awaited<ReturnType<typeof getClientProfile>>, TError = HTTPValidationError>(clientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientProfile>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientProfileQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientProfile>>> = ({ signal }) => getClientProfile(clientId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClientProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getClientProfile>>>
export type GetClientProfileQueryError = HTTPValidationError


/**
 * @summary Get Client Profile
 */

export function useGetClientProfile<TData = Awaited<ReturnType<typeof getClientProfile>>, TError = HTTPValidationError>(
 clientId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClientProfile>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClientProfileQueryOptions(clientId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






